import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Home, Wallet, Clock, FileText, UserCircle, LogOut, Building2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { useBrand } from "../lib/useBrand";

const NAV = [["/me", "Home", Home, true], ["/me/pay", "Pay", Wallet], ["/me/time", "Time", Clock], ["/me/documents", "Docs", FileText], ["/me/profile", "Profile", UserCircle]];

// Friendly mobile-first employee shell: soft header + pill bottom nav. Scoped by .emp-theme.
export default function EmployeeLayout() {
  const { user, logout } = useAuth();
  const brand = useBrand();
  const navigate = useNavigate();
  return (
    <div className="emp-theme min-h-screen flex flex-col" data-testid="employee-layout">
      <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-xl border-b border-slate-100 shadow-[0_2px_10px_rgb(0,0,0,0.02)]">
        <div className="max-w-2xl mx-auto px-6 h-16 flex items-center justify-between">
          <button onClick={() => navigate("/me")} className="flex items-center gap-3 min-w-0">
            {brand.logo ? <img src={brand.logo} alt="" className="h-9 w-9 rounded-xl object-contain bg-slate-50 p-1" /> : <span className="h-9 w-9 rounded-xl bg-blue-600 text-white font-extrabold grid place-items-center emp-display">P</span>}
            <span className="font-extrabold text-lg text-slate-900 emp-display truncate">{brand.name || "PostWage"}</span>
          </button>
          <div className="flex items-center gap-1">
            {user?.role === "client" && (
              <NavLink to="/client" data-testid="employee-back-to-company" className="inline-flex items-center gap-1.5 text-sm font-semibold text-sky-700 hover:text-sky-900 rounded-full px-3 py-2 hover:bg-sky-50 transition-colors"><Building2 className="h-4 w-4" /> Back to company</NavLink>
            )}
            <button data-testid="employee-logout" onClick={logout} className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-slate-900 rounded-full px-3 py-2 hover:bg-slate-100 transition-colors" title={user?.email}><LogOut className="h-4 w-4" /> Sign out</button>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-2xl w-full mx-auto px-5 py-7 pb-28"><Outlet /></main>
      <nav className="fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur-xl border-t border-slate-100" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="employee-nav">
        <div className="max-w-2xl mx-auto h-20 flex justify-around items-center px-2">
          {NAV.map(([to, label, Icon, end]) => (
            <NavLink key={to} to={to} end={end} data-testid={`employee-nav-${label === "Docs" ? "documents" : label.toLowerCase()}`}
              className={({ isActive }) => `flex flex-col items-center gap-1 px-4 sm:px-5 py-2 rounded-2xl text-[11px] font-bold transition-all duration-200 ease-out ${isActive ? "text-blue-600 bg-blue-50" : "text-slate-400 hover:text-slate-600"}`}>
              {({ isActive }) => (<><Icon className="h-6 w-6" strokeWidth={isActive ? 2.5 : 2} />{label}</>)}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
